const locations = {
    Burgenland: "Burgenland",
    Kärnten: "Kärnten",
    Niederösterreich: "Niederösterreich",
    Oberösterreich: "Oberösterreich",
    Salzburg:"Salzburg",
    Steiermark:"Steiermark",
    Tirol:"Tirol",
    Vorarlberg:"Vorarlberg",
    Wien:"Wien",
}

const jobData = [
{
    location: locations.Burgenland,
    year: 2010,
    ra: 61,
    raa: 24
},
{
    location: locations.Burgenland,
    year: 2018,
    ra: 68,
    raa: 29
},
{
    location: locations.Burgenland,
    year: 2019,
    ra: 70,
    raa: 21
},
{
    location: locations.Burgenland,
    year: 2020,
    ra: 73,
    raa: 23
},

{
    location: locations.Kärnten,
    year: 2010,
    ra: 268,
    raa: 62
},
{
    location: locations.Kärnten,
    year: 2018,
    ra: 259,
    raa: 66
},
{
    location: locations.Kärnten,
    year: 2019,
    ra: 262,
    raa: 76
},
{
    location: locations.Kärnten,
    year: 2020,
    ra: 262,
    raa: 67
},

{
    location: locations.Niederösterreich,
    year: 2010,
    ra: 401,
    raa: 111
},
{
    location: locations.Niederösterreich,
    year: 2018,
    ra: 457,
    raa: 129
},
{
    location: locations.Niederösterreich,
    year: 2019,
    ra: 464,
    raa: 123
},
{
    location: locations.Niederösterreich,
    year: 2020,
    ra: 474,
    raa: 117
},

{
    location: locations.Oberösterreich,
    year: 2010,
    ra: 619,
    raa: 210
},
{
    location: locations.Oberösterreich,
    year: 2018,
    ra: 681,
    raa: 216
},
{
    location: locations.Oberösterreich,
    year: 2019,
    ra: 685,
    raa: 211
},
{
    location: locations.Oberösterreich,
    year: 2020,
    ra: 690,
    raa: 205
},

{
    location: locations.Salzburg,
    year: 2010,
    ra: 402,
    raa: 98
},
{
    location: locations.Salzburg,
    year: 2018,
    ra: 421,
    raa: 112
},
{
    location: locations.Salzburg,
    year: 2019,
    ra: 425,
    raa: 102
},
{
    location: locations.Salzburg,
    year: 2020,
    ra: 423,
    raa: 94
},

{
    location: locations.Steiermark,
    year: 2010,
    ra: 509,
    raa: 174
},
{
    location: locations.Steiermark,
    year: 2018,
    ra: 571,
    raa: 183
},
{
    location: locations.Steiermark,
    year: 2019,
    ra: 566,
    raa: 203
},
{
    location: locations.Steiermark,
    year: 2020,
    ra: 568,
    raa: 206
},

{
    location: locations.Tirol,
    year: 2010,
    ra: 526,
    raa: 103
},
{
    location: locations.Tirol,
    year: 2018,
    ra: 541,
    raa: 127
},
{
    location: locations.Tirol,
    year: 2019,
    ra: 544,
    raa: 117
},
{
    location: locations.Tirol,
    year: 2020,
    ra: 551,
    raa: 128
},


{
    location: locations.Vorarlberg,
    year: 2010,
    ra: 277,
    raa: 48
},
{
    location: locations.Vorarlberg,
    year: 2018,
    ra: 242,
    raa: 36
},
{
    location: locations.Vorarlberg,
    year: 2019,
    ra: 243,
    raa: 36
},
{
    location: locations.Vorarlberg,
    year: 2020,
    ra: 236,
    raa: 42
},


{
    location: locations.Wien,
    year: 2010,
    ra: 2505,
    raa: 1072
},
{
    location: locations.Wien,
    year: 2018,
    ra: 3149,
    raa: 1406
},
{
    location: locations.Wien,
    year: 2019,
    ra: 3310,
    raa: 1448
},
{
    location: locations.Wien,
    year: 2020,
    ra: 3328,
    raa: 1388
},

]

export default jobData;